import { deleteCustomFieldSet, getCustomFieldSet, saveCustomFieldSet, updateCustomFieldSet } from "../CustomFieldSets/customFieldSetFuncs";
import { ClientConnectCustomFieldSet } from "../CustomFieldSets/types";

export const saveCustomDocumentSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet): Promise<boolean> => {
    const status = await saveCustomFieldSet(sid, fieldSet, 'document');
    return status;
}

export const updateCustomDocumentSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet, editFieldSet: ClientConnectCustomFieldSet): Promise<boolean> => {
    const status = await updateCustomFieldSet(sid, fieldSet, editFieldSet, 'document');
    return status;
}

export const getCustomDocumentSet = async (sid: string): Promise<ClientConnectCustomFieldSet[]> => {
    const customDocumentSets = await getCustomFieldSet(sid, 'document');
    return customDocumentSets;
}

export const deleteCustomDocumentSet = async (sid: string, fieldSetDelete: ClientConnectCustomFieldSet) => {
    const status = await deleteCustomFieldSet(sid, fieldSetDelete, 'document');
    return status;
}
